module.exports = __webpack_public_path__ + "static/img/android.cbe4fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/bycx/assets/img/android.png
// module id = N358
// module chunks = 1